<template minapp='mpx' xlang='wxml'>
  <view class='es-radio-group custom-class' wx:class="{{classnames}}">
    <slot />
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import radio from '../radio/index?resolve'
  createComponent({
    child: radio,
    componentName: 'RadioGroup',
    props: {
      disabled: Boolean,
      value: null,
      direction: {
        type: String,
        value: 'column'
      }
    },

    computed: {
      classnames() {
        return {
          [`es-radio-group--${this.direction}`]: true
        }
      }
    }
  })
</script>

<style lang='stylus'>
  @import '../common/style/bem'

  +b('radio-group')
    display flex
    flex-wrap wrap
    +m('column')
      flex-direction column
    +m('row')
      flex-direction row
</style>

<script name='json'>
  module.exports = {
    component: true
  }
</script>

